import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'

/* import all the icons in Free Solid, Free Regular, and Brands styles */
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'

library.add( fas, far )

export const Icons = {}

Icons.default = {
    Pen: <FontAwesomeIcon icon="fa-solid fa-pen" size='xs' />,
    Pan: <FontAwesomeIcon icon="fa-solid fa-hand" size='xs' />,
    Hand: <FontAwesomeIcon icon="fa-solid fa-hand" size='xs' />,
    Plus: <FontAwesomeIcon icon="fa-solid fa-plus" size='xs' />,
    Lock: <FontAwesomeIcon icon="fa-solid fa-lock" size='xs' />,
    Undo: <FontAwesomeIcon icon="fa-solid fa-rotate-left" size='xs' />,
    Redo: <FontAwesomeIcon icon="fa-solid fa-rotate-right" size='xs' />,
    MoreOptions: <FontAwesomeIcon icon="fa-solid fa-ellipsis-vertical" size='xs' />,
    Tools: <FontAwesomeIcon icon="fa-solid fa-screwdriver-wrench" size='xs' />,
    Broom: <FontAwesomeIcon icon="fa-solid fa-broom" size='xs' />,
    Palette: <FontAwesomeIcon icon="fa-solid fa-palette" size='xs' />,
    Download: <FontAwesomeIcon icon="fa-solid fa-download" size='xs' />,
    Expand: <FontAwesomeIcon icon="fa-solid fa-expand" size='xs' />,
    Compress: <FontAwesomeIcon icon="fa-solid fa-compress" size='xs' />,
    Pencil: <FontAwesomeIcon icon="fa-solid fa-pencil" size='xs' />,
    CloseIcon: <FontAwesomeIcon icon="fa-solid fa-xmark" size='xs' />,
    Circle: <FontAwesomeIcon icon="fa-regular fa-circle" size='xs' />,
    Eraser: <FontAwesomeIcon icon="fa-solid fa-eraser" size='xs' />,
    Rect: <FontAwesomeIcon icon="fa-regular fa-square" size='xs' />,
    Text: <FontAwesomeIcon icon="fa-solid fa-font" size='xs' />,
    TextCursor: <FontAwesomeIcon icon="fa-solid fa-i-cursor" size='xs' />,
    Select: <FontAwesomeIcon icon="fa-solid fa-arrow-pointer" size='xs' />,
    FilledRect: <FontAwesomeIcon icon="fa-solid fa-square" size='xs' />,
    Highlighter: <FontAwesomeIcon icon="fa-solid fa-highlighter" size='xs' />,
    PaintBrush: <FontAwesomeIcon icon="fa-solid fa-paintbrush" size='xs' />,
    ChevronLeft: <FontAwesomeIcon icon="fa-solid fa-chevron-left" size='xs' />,
    ChevronRight: <FontAwesomeIcon icon="fa-solid fa-chevron-right" size='xs' />,
    ZoomIn: <FontAwesomeIcon icon="fa-solid fa-magnifying-glass-plus" size='xs' />,
    ZoomOut: <FontAwesomeIcon icon="fa-solid fa-magnifying-glass-minus" size='xs' />,
}

export const VIRTUALBOARD_TOOLS = {
    pencil: { lineWidth: 0.7, lineCap: 'round', lineJoin: 'round', opacity: 1 },
    pen: { lineWidth: 1, lineCap: 'round', lineJoin: 'round', opacity: 1 },
    marker: { lineWidth: 5, lineCap: 'round', lineJoin: 'round', opacity: 0.4, lineDash: [] },
    eraser: { shadowBlur: 20, shadow: true, lineWidth: 40, lineCap: 'round', lineJoin: 'round', lineDash: [], color: { name: 'Lavender', r: 188, g: 171, b: 207, hex: '#bcabcfff' } },
    laser: { shadowBlur: 20, shadow: true, lineWidth: 3, lineCap: 'round', color: { name: 'Red', r: 255, g: 0, b: 0, hex: '#ff0000' }, lineJoin: 'round', lineDash: [] },
}

export const ANNOTATION_COLORS = [
    { name: 'Red', r: 255, g: 0, b: 0, hex: '#ff0000' },
    { name: 'Green', r: 60, g: 180, b: 75, hex: '#3cb44b' },
    { name: 'Yellow', r: 255, g: 225, b: 25, hex: '#ffe119' },
    { name: 'Blue', r: 0, g: 130, b: 200, hex: '#0082c8' },
    { name: 'Orange', r: 245, g: 130, b: 48, hex: '#f58231' },
    { name: 'Purple', r: 145, g: 30, b: 180, hex: '#911eb4' },
    { name: 'Cyan', r: 70, g: 240, b: 240, hex: '#46f0f0' },
    { name: 'Magenta', r: 240, g: 50, b: 230, hex: '#f032e6' },
    { name: 'Lime', r: 191, g: 239, b: 69, hex: '#bcf60c' },
    { name: 'Pink', r: 250, g: 190, b: 190, hex: '#fabed4' },
    { name: 'Teal', r: 0, g: 128, b: 128, hex: '#008080' },
    { name: 'Lavender', r: 220, g: 190, b: 255, hex: '#dcbeff' },
    { name: 'Brown', r: 154, g: 99, b: 36, hex: '#9a6324' },
    { name: 'Beige', r: 255, g: 250, b: 200, hex: '#fffac8' },
    { name: 'Maroon', r: 128, g: 0, b: 0, hex: '#800000' }
]


let debounceTimeoutIds = {}
export const debounce = ( debounceId, func, delay ) => {
    return ( ...args ) => {
        if ( debounceTimeoutIds[debounceId] ) clearTimeout( debounceTimeoutIds[debounceId] )
        debounceTimeoutIds[debounceId] = setTimeout( () => {
            func.apply( null, args )
        }, delay )
    }
}

const isOnRectStroke = ( pos, el, tolerance ) => {
    const { x, y, width, height } = el

    const withinX = pos.x >= x - tolerance && pos.x <= x + width + tolerance
    const withinY = pos.y >= y - tolerance && pos.y <= y + height + tolerance
    const onLeft = Math.abs( pos.x - x ) <= tolerance && pos.y >= y - tolerance && pos.y <= y + height + tolerance
    const onRight = Math.abs( pos.x - ( x + width ) ) <= tolerance && pos.y >= y - tolerance && pos.y <= y + height + tolerance
    const onTop = Math.abs( pos.y - y ) <= tolerance && pos.x >= x - tolerance && pos.x <= x + width + tolerance
    const onBottom = Math.abs( pos.y - ( y + height ) ) <= tolerance && pos.x >= x - tolerance && pos.x <= x + width + tolerance

    return ( withinX && withinY ) && ( onLeft || onRight || onTop || onBottom )
}

const isPointNearLine = ( p, a, b, tolerance ) => {
    const dx = b.x - a.x
    const dy = b.y - a.y
    const length = Math.sqrt( dx * dx + dy * dy )
    const t = ( ( p.x - a.x ) * dx + ( p.y - a.y ) * dy ) / ( length * length )
    if ( t < 0 || t > 1 ) return false
    const nearestX = a.x + t * dx
    const nearestY = a.y + t * dy
    const dist = Math.hypot( p.x - nearestX, p.y - nearestY )
    return dist <= tolerance
}


export const findHoveredShape = ( pos, elements ) => {
    for ( const shape of elements ) {
        const { x, y, width, height, centerX: cx, centerY: cy, radiusX: rx, radiusY: ry, points, type, id, fill } = shape
        if ( type === "stroke" ) {
            for ( let i = 0; i < points.length - 1; i++ ) {
                const a = points[i]
                const b = points[i + 1]
                if ( isPointNearLine( pos, a, b, 0.01 ) ) {
                    return id
                }
            }
        } else if ( type === 'rect' || type === 'text' ) {
            if ( fill && pos.x >= x && pos.x <= x + width && pos.y >= y && pos.y <= y + height )
                return id
            if ( !fill && isOnRectStroke( pos, shape, 0.01 ) )
                return id
        } else if ( type === 'circle' ) {
            const dx = pos.x - cx
            const dy = pos.y - cy
            const p = ( ( dx * dx ) / ( rx * rx ) ) + ( ( dy * dy ) / ( ry * ry ) )

            if ( p < 1.05 && p > 0.95 )
                return id
        }
    }
    return null
}

export const isPointInsideElement = ( point, element ) => {
    const { x, y, width, height, centerX, centerY, radiusX, radiusY, points, type } = element

    if ( type === "rect" || type === "text" ) {
        return point.x >= x && point.x <= x + width && point.y >= y && point.y <= y + height
    } else if ( type === "circle" ) {
        const cx = centerX
        const cy = centerY
        const rx = radiusX
        const ry = radiusY
        const dx = point.x - cx
        const dy = point.y - cy

        return ( ( dx * dx ) / ( rx * rx ) ) + ( ( dy * dy ) / ( ry * ry ) ) <= 1
    } else if ( type === "stroke" ) {
        // simple: check if point is close to any stroke point
        return points.some( p => Math.hypot( p.x - point.x, p.y - point.y ) <= 0.01 ) // 10px tolerance
    }
    return false
}

export const normalizePoint = ( p, width, height ) => ( {
    x: p.x / width,
    y: p.y / height
} )
export const getCanvasCSSSize = ( canvas ) => {
    const rect = canvas.getBoundingClientRect()
    return { width: rect.width, height: rect.height }
}

export const getPos = ( e, canvas, pan, zoom ) => {
    if ( !canvas ) return null

    const rect = canvas.getBoundingClientRect()

    // Mouse in CSS px relative to canvas top-left
    const xCss = e.clientX - rect.left
    const yCss = e.clientY - rect.top

    // Inverse of setTransform(zoom * dpr, pan * dpr) in CSS space:
    // world (CSS) = (screenCss - pan) / zoom
    const world = {
        x: ( xCss - pan.x ) / zoom,
        y: ( yCss - pan.y ) / zoom,
    }

    const { width: boardW, height: boardH } = { width: rect.width, height: rect.height }

    const positions = {}
    positions.page = world                // world in CSS px
    positions.canvas = { x: xCss, y: yCss } // raw screen CSS px

    positions.normalizedPage = normalizePoint( world, boardW, boardH )
    positions.normalizedCanvas = normalizePoint( positions.canvas, boardW, boardH )

    return positions
}



export const constrainPan = ( panX, panY, zoom, canvasWidth, canvasHeight, containerWidth, containerHeight ) => {
    // Scaled image dimensions
    const scaledWidth = canvasWidth * zoom
    const scaledHeight = canvasHeight * zoom

    // Compute min/max pan so image sticks to edges
    const minX = Math.min( 0, containerWidth - scaledWidth )
    const maxX = 0
    const minY = Math.min( 0, containerHeight - scaledHeight )
    const maxY = 0

    const constrainedX = Math.max( minX, Math.min( panX, maxX ) )
    const constrainedY = Math.max( minY, Math.min( panY, maxY ) )

    return { x: constrainedX, y: constrainedY }
}